"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTrainerContext = exports.TrainerProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const TrainerContext = (0, react_1.createContext)(null);
function TrainerProvider({ children, trainer }) {
    return (0, jsx_runtime_1.jsx)(TrainerContext.Provider, { value: trainer, children: children });
}
exports.TrainerProvider = TrainerProvider;
function useTrainerContext() {
    const trainer = (0, react_1.useContext)(TrainerContext);
    if (!trainer)
        throw new Error("useTrainerContext must be used inside a TrainerProvider");
    return trainer;
}
exports.useTrainerContext = useTrainerContext;
